const selector = {
    form: '#form_checkout',
    btnSubmit: '#btn_submit',
    checkTerms: '#check_terms',
    languageSwithch: '.language-switch',
}

export {selector};